import { createContext } from 'react';

import { PanelSize } from './types';

export interface PanelContextType {
  resizePanel: (size: Partial<PanelSize>) => void;
  initialResizePanel: (size: Partial<PanelSize>) => void;
  resizeable: boolean;
}

const NoContextError = () => {
  console.error('Missing PanelContext Provider');
};

/**
 * Provides access to closing/popping panels
 */
export const PanelContext = createContext<PanelContextType>({
  resizePanel: NoContextError,
  initialResizePanel: NoContextError,
  resizeable: true,
});
